import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import axios from 'axios';
import Header from '../../Components/Header';
import { Spinner } from 'react-bootstrap';
import { BASE_URL, paybridge_Url } from '../../Config';

const Sales = () => {
  const [agentId, setAgentId] = useState('');
  const [agentName, setAgentName] = useState('');
  const [CustomerName, setCustomerName] = useState('');
  const [mobileNo, setMobileNo] = useState('');
  const [cnic, setCnic] = useState('');
  const [status, setStatus] = useState('Completed');
  const [gender, setGender] = useState('');
  const [packageId, setPackageId] = useState('');
  const [Remarks, setRemarks] = useState('');
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [companyId, setCompanyId] = useState('');
  const [companyName, setCompanyName] = useState('');

  useEffect(() => {
    const storedUserData = sessionStorage.getItem('user');
    if (!storedUserData) return;

    const parsedData = JSON.parse(storedUserData);

    setAgentId(parsedData.userId);
    setAgentName(parsedData.name);
    setCompanyId(parsedData.companyId || 'COMP001');
    setCompanyName(parsedData.companyName || 'Default Company');

    axios.get(`${BASE_URL}RetailAgentGetPackage?id=${parsedData.userId}`)
      .then(response => {
        if (response.data.responseCode === '0000') {
          setPackages(response.data.packages);
        } else {
          Swal.fire('Error', 'Failed to load packages.', 'error');
        }
      })
      .catch(() => {
        Swal.fire('Error', 'An error occurred while fetching packages.', 'error');
      });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = [];
    // if (!CustomerName) errors.push('Name is required.');
    if (!mobileNo) errors.push('Mobile Number is required.');
    // if (!gender) errors.push('Gender is required.');
    if (!packageId) errors.push('Package is required.');
    // CNIC is optional - not required

    if (errors.length > 0) {
      Swal.fire('Error', errors.join('\n'), 'error');
      return;
    }

    const selectedPackage = packages.find(pkg => pkg.packageid === parseInt(packageId));
    const amount = selectedPackage?.packagePrice || 0;

    // productCode / productType / companyProduct - package se lene ki koshish,
    // na milne par hardcoded fallback values use hongi
    const productCode = selectedPackage?.packageCode;
    const productType = selectedPackage?.productType ;
    const companyProduct = selectedPackage?.packageName || selectedPackage?.packageName;

    // Expiry date = Pakistan current date + packageDuration (e.g. "60 Days")
    const durationMatch = selectedPackage?.packageDuration?.match(/\d+/);
    const durationDays = durationMatch ? parseInt(durationMatch[0], 10) : 30; // fallback 30 days

    // Pakistan Standard Time is UTC+5
    const nowUtc = new Date();
    const pktNow = new Date(nowUtc.getTime() + (5 * 60 + nowUtc.getTimezoneOffset()) * 60000);
    pktNow.setDate(pktNow.getDate() + durationDays);

    const pad = (n) => String(n).padStart(2, '0');
    const expiredAt = `${pktNow.getFullYear()}-${pad(pktNow.getMonth() + 1)}-${pad(pktNow.getDate())} 23:59:59`;

    setLoading(true);
    try {
      const response = await axios.post(
        `${paybridge_Url}process`,
        {
          productType,
          CustomerName: CustomerName || null,
          Remarks: Remarks || null,
          agent_Name: agentName,
          agent_id: agentId,
          amount: String(amount),
          cnic: cnic || null,
          productCode,
          companyProduct,
          company_Name: companyName,
          company_id: companyId,
          msisdn: mobileNo,
          expired_at: expiredAt,
        },
        { headers: { 'Content-Type': 'application/json' } }
      );

      setLoading(false);

      const resBody = response.data;
      const ppCode = resBody?.data?.pp_ResponseCode;

      if (resBody.status === 'ALREADY_SUBSCRIBED') {
        // Already subscribed case
        Swal.fire({
          icon: 'warning',
          title: 'Already Subscribed',
          text: resBody.message || 'Customer already subscribed within 365 days.',
        });
      } else if (productType === 'TPL_PAYMENT') {
        // TPL_PAYMENT response has no response_code/pp_ResponseCode field -
        // success:true alone confirms the payment URL/SMS was triggered
        if (resBody.success) {
          Swal.fire({
            icon: 'success',
            title: 'Payment Link Sent',
            text: resBody.message || 'Payment URL generated and SMS sent to customer.',
          }).then(() => {
            window.location.reload();
          });
        } else {
          console.error('TPL payment failed - full response:', resBody);
          let failureMsg = resBody.message || 'Payment failed. Please try again.';
          // Backend ka message valid productType list expose kar deta hai
          // (e.g. "Unknown productType: ... Valid types: TPL_PAYMENT, MWALLET..."),
          // usko user ko nahi dikhana - sirf generic "Unknown productType" rakho
          if (/unknown productType/i.test(failureMsg)) {
            failureMsg = 'Unknown productType';
          }
          Swal.fire({
            icon: 'error',
            title: 'Transaction Failed',
            text: failureMsg,
          });
        }
      } else if (resBody.success && resBody.response_code === '000' && ppCode === '000') {
        // MWALLET genuine success - both top-level and gateway response codes confirm it
        Swal.fire({
          icon: 'success',
          title: 'Payment Successful',
          text: resBody.message || 'Payment processed successfully.',
        }).then(() => {
          window.location.reload();
        });
      } else {
        // MWALLET: success:true ke bawajood response_code/pp_ResponseCode failure
        // ko indicate kar sakta hai, isliye yeh case bhi yahan handle hota hai
        console.error('Payment failed - full response:', resBody);

        let failureText = resBody.message || resBody?.data?.pp_ResponseMessage || 'Payment failed. Please try again.';
        // Backend ka message valid productType list expose kar deta hai,
        // usko user ko nahi dikhana - sirf generic "Unknown productType" rakho
        if (/unknown productType/i.test(failureText)) {
          failureText = 'Unknown productType';
        }
        const refNo = resBody.txnRefNo || resBody?.data?.pp_TxnRefNo;

        Swal.fire({
          icon: 'error',
          title: 'Transaction Failed',
          html: refNo
            ? `${failureText}<br/><small class="text-muted">Ref No: ${refNo}</small>`
            : failureText,
        });
      }

    } catch (error) {
      setLoading(false);
      Swal.fire('Error', error.response?.data?.message || 'An error occurred while processing payment.', 'error');
    }
  };

  return (
    <>
      <Header />
      <div className="container-fluid d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
        <div className="row justify-content-center w-100">
          <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 col-xxl-4 col-xxxl-3">
            <div className="card shadow-sm">
              <div className="card-body">

                <div className="text-center mb-4">
                  <h4>Register Customer</h4>
                </div>

                <form onSubmit={handleSubmit}>
                  {/* NAME + MOBILE */}
                  <div className="row mb-3">
                    <div className="col-12 col-md-6">
                      <label className="form-label">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter full name"
                        value={CustomerName}
                        onChange={(e) => setCustomerName(e.target.value)}
                      />
                    </div>

                    <div className="col-12 col-md-6">
                      <label className="form-label">Mobile No</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="e.g. 03001234567"
                        value={mobileNo}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,11}$/.test(value)) {
                            if (value.length <= 2) setMobileNo('03'.slice(0, value.length));
                            else if (value.startsWith('03')) setMobileNo(value);
                          }
                        }}
                      />
                    </div>
                  </div>

                  {/* CNIC (optional) + GENDER */}
                  <div className="row mb-3">
                    <div className="col-12 col-md-6">
                      <label className="form-label">CNIC <span className="text-muted">(optional)</span></label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter 6 digit CNIC"
                        value={cnic}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,6}$/.test(value)) setCnic(value);
                        }}
                      />
                    </div>

                    <div className="col-12 col-md-6">
                      <label className="form-label">Gender</label>
                      <select
                        className="form-select"
                        value={gender}
                        onChange={(e) => setGender(e.target.value)}
                      >
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                  </div>

                  {/* PACKAGE */}
                  <div className="row mb-3">
                    <div className="col-12">
                      <label className="form-label">Package</label>
                      <select
                        className="form-select"
                        value={packageId}
                        onChange={(e) => setPackageId(e.target.value)}
                      >
                        <option value="">Select Package</option>
                        {packages.map(pkg => (
                          <option key={pkg.packageid} value={pkg.packageid}>
                            {pkg.packageName} - Rs.{pkg.packagePrice}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* REMARKS */}
                  <div className="mb-3">
                    <label className="form-label">Remarks</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      placeholder="Enter remarks (optional details)"
                      value={Remarks}
                      onChange={(e) => setRemarks(e.target.value)}
                    />
                  </div>

                  {/* SUBMIT BUTTON */}
                  <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                    {loading ? <><Spinner size="sm" /> Processing...</> : 'Pay & Register'}
                  </button>

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sales;